import { useEffect, useState } from "react";
import { api } from "./api";

export interface CardCounts {
  timesheet: number;
  expense: number;
  unknown: number;
  conflict: number;
  archived: number;
  total: number;
  /** Zähler pro doc_type (card #523). Keys = die DISTINCT-doc_type-Menge der
   *  aktiven Karten — die Quelle der historischen "(inaktiv)"-Filter-Tabs. */
  by_doc_type: Record<string, number>;
}

const EMPTY_COUNTS: CardCounts = {
  timesheet: 0,
  expense: 0,
  unknown: 0,
  conflict: 0,
  archived: 0,
  total: 0,
  by_doc_type: {},
};

/**
 * Pollt `/api/cards/counts` alle 3 s (gleiche Cadence wie `useKanbanPoll`).
 * Liefert IMMER alle vier Buckets — die Tab-Auswahl im Kanban ändert nur
 * welche Cards in der Liste sind, NICHT was die Counter zeigen.
 *
 * Vor diesem Hook (2026-05-19): KanbanPage hat aus dem bereits gefilterten
 * cards[]-Array clientseitig gezählt — Tabs außer „Alle" zeigten 0 für die
 * nicht-aktiven Kategorien obwohl die Karten tatsächlich existierten. Drift
 * sichtbar im Werkstatt-Tab „Bestand" (Drift-Check Step).
 */
export function useCardsCounts(month?: string, clientId?: string): CardCounts {
  const [counts, setCounts] = useState<CardCounts>(EMPTY_COUNTS);
  useEffect(() => {
    let alive = true;
    const fetchOnce = async () => {
      if (document.hidden) return;  // tab unsichtbar → kein poll
      try {
        const r = await api.cards.counts(month, clientId);
        if (alive) setCounts(r);
      } catch {
        // silent — Counter bleiben auf letztem bekannten Stand
      }
    };
    fetchOnce();
    // Cadence von 3s auf 5s erhöht (2026-05-19): Polling-Storm-Audit zeigte
    // unnötige DB-Last; 5s ist immer noch hinreichend schnell für Live-Gefühl.
    const t = setInterval(fetchOnce, 5000);
    const onVis = () => { if (!document.hidden) fetchOnce(); };
    document.addEventListener("visibilitychange", onVis);
    return () => {
      alive = false;
      clearInterval(t);
      document.removeEventListener("visibilitychange", onVis);
    };
  }, [month, clientId]);
  return counts;
}
